import { render, staticRenderFns } from "./sports.vue?vue&type=template&id=f385c87e&scoped=true&"
import script from "./sports.vue?vue&type=script&lang=js&"
export * from "./sports.vue?vue&type=script&lang=js&"
import style0 from "./sports.vue?vue&type=style&index=0&id=f385c87e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f385c87e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SportIcon: require('/var/web/bet777.es/components/sport/icon.vue').default,UiCardWrapper: require('/var/web/bet777.es/themes/dark/ui/Card/Wrapper.vue').default})
